__turbopack_context__.v({
  "casesTextContainer": "tile-module-scss-module__tUTaUG__casesTextContainer",
  "image": "tile-module-scss-module__tUTaUG__image",
  "imageContainer": "tile-module-scss-module__tUTaUG__imageContainer",
  "newsTextContainer": "tile-module-scss-module__tUTaUG__newsTextContainer",
  "newsTitleContainer": "tile-module-scss-module__tUTaUG__newsTitleContainer",
  "tagsContainer": "tile-module-scss-module__tUTaUG__tagsContainer",
  "teamImage": "tile-module-scss-module__tUTaUG__teamImage",
  "teamTextContainer": "tile-module-scss-module__tUTaUG__teamTextContainer",
  "textContainer": "tile-module-scss-module__tUTaUG__textContainer",
  "tileContainer": "tile-module-scss-module__tUTaUG__tileContainer",
});
